import * as React from 'react';
import styled from 'styled-components';

declare interface IProps {
  direction?: 'vertical' | 'horizontal' | 'split';
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  wrapperStyle?: React.CSSProperties;
}

const Single = styled.div`
  overflow-y: scroll;
  display: grid;
  flex: 1;
  grid-template-rows: auto;
  padding: 10px 5px 15px 20px;
  @media (max-width: 990px) {
    padding: 10px 5px 10px 10px;
  }
`;

const Horizontal = styled.div`
  display: grid;
  flex: 1;
  grid-template-columns: repeat(24, 1fr);
  grid-gap: var(--grid-gap);
  grid-template-rows: repeat(24, 1fr);
  padding: 10px 20px 10px 20px;
  height: 100%;
  @media (max-width: 990px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    padding: 10px 10px 15px 10px;
  }
`;

const Split = styled.div`
  overflow-y: scroll;
  flex: 1;
  display: grid;
  grid-template-columns: 50fr 50fr;
  grid-gap: var(--grid-gap);
  grid-template-rows: auto 1fr;
  padding: 0px 5px 15px 20px;
  height: 100%;
  @media (max-width: 990px) {
    grid-template-columns: 1fr;
    padding: 10px 5px 15px 10px;
    grid-template-rows: auto;
  }
`;

const Vertical = styled.div`
  overflow-y: scroll;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto;
  flex: 1;
  padding: 10px 0px 15px 20px;
  @media (max-width: 990px) {
    padding: 10px 5px 15px 10px;
  }
`;

const Wrapper = styled.div`
  height: 100vh;
  padding-top: 60px;
  @media (max-width: 990px) {
    height: calc(100% - 50px);
    min-height: calc(100% - 50px);
  }
`;

const SplitBottom = styled.div`
  grid-column-start: 1;
  grid-column-end: 3;
  grid-template-rows: auto 1fr;
  @media (max-width: 990px) {
    grid-column-start: 1;
    grid-column-end: 2;
  }
`;

const Container = (props: IProps): React.ReactElement => {
  const renderGrid = (): React.ReactElement => {
    switch (props.direction) {
      case 'horizontal':
        return (
          <Horizontal style={props.style} className={props.className}>
            {props.children}
          </Horizontal>
        );
      case 'vertical':
        return (
          <Vertical style={props.style} className={props.className}>
            {props.children}
          </Vertical>
        );
      case 'split':
        return (
          <Split style={props.style} className={props.className}>
            {props.children}
          </Split>
        );
      default:
        return (
          <Single style={props.style} className={props.className}>
            {props.children}
          </Single>
        );
    }
  };
  return (
    <React.Fragment>
      <Wrapper style={props.wrapperStyle}>{renderGrid()}</Wrapper>
    </React.Fragment>
  );
};

const MainGrid = (props: IProps): React.ReactElement => {
  return <Container {...props} />;
};

export { MainGrid, SplitBottom };
